import * as THREE from 'three'
import { xDaEstruturaNaAltura, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { formaVidroLateral, type ContornoVidroLateral } from './formasCarroceria'

export const ESPESSURA_VIDRO_LATERAL = 0.022
const GEOMETRIAS = new Map<string, THREE.ExtrudeGeometry>()

/** Face externa do vidro na cintura, dentro da chapa da porta. */
export function xDoVidroNaCintura(perfil: PerfilVeiculo, sinal: number): number {
  const externo = xDaEstruturaNaAltura(perfil, sinal, perfil.cinturaY) + sinal * 0.04
  return externo + (sinal < 0 ? ESPESSURA_VIDRO_LATERAL : 0)
}

/** A extrusão local aponta para -X depois do giro; sua própria largura acompanha a coluna. */
export function geometriaVidroLateral(
  perfil: PerfilVeiculo,
  sinal: number,
  contorno: ContornoVidroLateral,
): THREE.ExtrudeGeometry {
  const chave = `${perfil.id}:${sinal}:${perfil.recuoLateralTeto}:${perfil.arqueamentoLateralColunas}:${JSON.stringify(contorno)}`
  const existente = GEOMETRIAS.get(chave)
  if (existente) return existente
  const geometria = new THREE.ExtrudeGeometry(formaVidroLateral(contorno), {
    depth: ESPESSURA_VIDRO_LATERAL,
    bevelEnabled: false,
  })
  const posicoes = geometria.getAttribute('position') as THREE.BufferAttribute
  const base = Math.abs(xDaEstruturaNaAltura(perfil, sinal, perfil.cinturaY))
  for (let i = 0; i < posicoes.count; i++) {
    const recuo = base - Math.abs(xDaEstruturaNaAltura(perfil, sinal, posicoes.getY(i)))
    posicoes.setZ(i, posicoes.getZ(i) + sinal * recuo)
  }
  posicoes.needsUpdate = true
  geometria.computeVertexNormals()
  GEOMETRIAS.set(chave, geometria)
  return geometria
}
